module.exports = __webpack_public_path__ + "static/media/Pin_battery-icon.1f43f08f.svg";